import { FirebaseError } from "firebase/app";
import {
  Auth,
  getMultiFactorResolver,
  MultiFactorError,
  MultiFactorResolver,
} from "firebase/auth";

// getResolverFromError checks if the provided error is a MultiFactorError and returns
// the corresponding MultiFactorResolver if it is. If the error is not a MultiFactorError,
// it returns null.
export function getResolverFromError(
  auth: Auth,
  error: unknown,
): MultiFactorResolver | null {
  if (
    error instanceof FirebaseError &&
    error.code === "auth/multi-factor-auth-required" &&
    error.customData &&
    typeof error.customData === "object" &&
    "appName" in error.customData &&
    "operationType" in error.customData
  ) {
    return getMultiFactorResolver(auth, error as MultiFactorError);
  }
  return null;
}
